import { Grid } from '@material-ui/core';
import { createTextField, createSelectField, createNumberFormatField } from '@roc/ui/componentBuilder';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { LOAN_SUPPORT } from '../../utils/generalTasksConstants';
import { SUPPORT_OPTIONS } from '../../utils/generalTasksConstants';
import { useEffect } from 'react';
import { DialogState } from '@roc/ui';
export const CreateSuportTask = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const { isReadOnly, } = editTaskStore;
  const store = editTaskStore;
  const selectedCategory = store.getValue('category')

  useEffect(() => {
    if (editTaskStore.dialogState === DialogState.ADD) {
      editTaskStore.onFieldChange('category', 'TECH_SUPPORT');
    }
  }, []);

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12}>
        {createSelectField({
          store: store,
          testId: 'categorySupport',
          fieldName: 'category',
          label: 'Category *',
          options: SUPPORT_OPTIONS,
          disabled: isReadOnly
        })}
      </Grid> */}
      {selectedCategory === LOAN_SUPPORT && (
        <Grid item xs={12}>
          {createNumberFormatField({
            store,
            testId: 'loanId',
            fieldName: 'loanId',
            label: 'Loan Id *',
            allowNegative: false,
            disabled: isReadOnly
          })}
        </Grid>
      )}
      <Grid item xs={12}>
        {createTextField({
          store,
          testId: 'title',
          fieldName: 'title',
          label: 'Description',
          disabled: isReadOnly,
          multiline: true,
          minRows: 3,
        })}
      </Grid>
    </Grid>
  );
});